import {
  useCallback, useState, useEffect
} from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import MiniPlayer from './MiniPlayer';
import MusicPlayerFull from '@/components/app/MusicPlayerFull';

const PlayerBarMobile = ({
  isOpen,
  onMoveEpisode,
  isFiltered
}) => {
  const { asPath } = useRouter();
  const [fullScreen, setFullScreen] = useState(false); // Track whether the music player is in full screen mode

  // Close full screen player when the route changes
  useEffect(() => {
    setFullScreen(false);
  }, [asPath]);

  // ------ Handlers for user interaction ------
  const handleClickPlayer = useCallback(() => {
    setFullScreen(true);
  }, []);

  const handleCloseFullScreen = useCallback(() => {
    setFullScreen(false);
  }, []);

  return (
    <>
      <MiniPlayer
        isFiltered={ isFiltered }
        isOpen={ isOpen }
        onClickPlayer={ handleClickPlayer }
      />
      <MusicPlayerFull
        isOpen={ fullScreen }
        onClose={ handleCloseFullScreen }
        onMoveEpisode={ onMoveEpisode }
      />
    </>
  );
};

PlayerBarMobile.propTypes = {
  isOpen: PropTypes.bool,
  onMoveEpisode: PropTypes.func.isRequired,
  isFiltered: PropTypes.bool
};

PlayerBarMobile.defaultProps = {
  isOpen: false,
  isFiltered: false
};

export default PlayerBarMobile;